import React from 'react';
import {Pane, PaneProps} from 'evergreen-ui';
import {MemoDatasourceTypeSelect} from '../DatasourceTypesSelect';
import {useSelectedDatasourceTypesIds} from '../hooks';
import {DatasourcesFilterByStatuses} from './FilterByStatuses';

/**
 * Фильтры источника с выбранными данными из `filterSlice`
 */
export function DatasourcesFilter(props: PaneProps) {
  const { datasourceTypesIds, onChangeDatasourceTypesIds } = useSelectedDatasourceTypesIds();
  return (
    <Pane display="flex" gap=".2rem" {...props}>
      <MemoDatasourceTypeSelect selected={datasourceTypesIds} onSelect={onChangeDatasourceTypesIds} />
      <DatasourcesFilterByStatuses />
    </Pane>
  );
}
export default DatasourcesFilter;
